import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';

interface SimplePriceInputProps {
  value: number;
  onChange: (value: number) => void;
  placeholder?: string;
  label?: string;
  disabled?: boolean;
  className?: string;
  size?: 'sm' | 'lg';
  error?: string;
}

const SimplePriceInput: React.FC<SimplePriceInputProps> = ({
  value,
  onChange,
  placeholder = 'R$ 0,00',
  label,
  disabled = false,
  className = '',
  size,
  error
}) => {
  const [displayValue, setDisplayValue] = useState('');

  // Função para formatar preço
  const formatPrice = (num: number): string => {
    if (num === 0) return '';
    return `R$ ${num.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
  };

  // Função para converter string formatada para número
  const parsePrice = (str: string): number => {
    if (!str) return 0;
    const clean = str.replace(/[R$\s.]/g, '').replace(',', '.');
    const num = parseFloat(clean);
    return isNaN(num) ? 0 : num;
  };

  // Atualiza o valor de exibição quando o valor prop muda
  useEffect(() => {
    setDisplayValue(formatPrice(value));
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    
    // Se está vazio, limpa
    if (!inputValue || inputValue === 'R$ ') {
      setDisplayValue('');
      onChange(0);
      return;
    }
    
    // Remove tudo que não é dígito
    const numbers = inputValue.replace(/\D/g, '');
    
    if (!numbers) {
      setDisplayValue('');
      onChange(0);
      return;
    }
    
    // Converte para centavos
    const amount = parseInt(numbers, 10) / 100;
    
    // Formata
    const formatted = formatPrice(amount);
    
    // Atualiza
    setDisplayValue(formatted);
    onChange(amount);
  };

  return (
    <Form.Group className={className}>
      {label && <Form.Label>{label}</Form.Label>}
      <Form.Control
        type="text"
        value={displayValue}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        size={size}
        isInvalid={!!error}
        className="text-end"
      />
      {error && <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>}
    </Form.Group>
  );
};

export default SimplePriceInput;

